"use strict";
/**
 * This module re-exports all the base units for backwards compability
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Second = exports.Mole = exports.Meter = exports.Kilogram = exports.Kelvin = exports.Candela = exports.Ampere = void 0;
var uom_1 = require("uom");
exports.Ampere = uom_1.BaseUnits.Ampere;
exports.Candela = uom_1.BaseUnits.Candela;
exports.Kelvin = uom_1.BaseUnits.Kelvin;
exports.Kilogram = uom_1.BaseUnits.Kilogram;
exports.Meter = uom_1.BaseUnits.Meter;
exports.Mole = uom_1.BaseUnits.Mole;
exports.Second = uom_1.BaseUnits.Second;
//# sourceMappingURL=base-units.js.map